import { render, staticRenderFns } from "./DropdownValueDeleteConfirmation.vue?vue&type=template&id=20b4eac6"
import script from "./DropdownValueDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./DropdownValueDeleteConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports